import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 43,
  label: "申请人年度授权量分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [
      {
        name: "applicantNewName",
        label: "申请人",
        table: "patent_applicant",
        limit: 10,
        needTotal: true,
      },
    ],
    colDims: [{ name: "authDate", label: "授权年", dateUnit: "YEAR", limit: 10, needTotal: true }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true,
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "申请人年度授权量分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false,
  },
};
